import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PRIMARY_LIGHT_BLUE, WHITE } from "../../colors";

const ButtonModified = styled(Button)(({ theme }) => ({
  backgroundColor: WHITE,
  color: PRIMARY_LIGHT_BLUE,
  minWidth: 200,
  border: `${PRIMARY_LIGHT_BLUE} solid 1px`,
  height: 42,
  borderRadius: 10,
  textTransform: "none",
  fontFamily: theme.typography.fontFamily,
  fontSize: 18,
  fontWeight: 800,
  letterSpacing: 1,
}));

export default function CutomButton(props) {
  const { text, onClick } = props;
  return (
    <ButtonModified onClick={onClick} variant="contained" disableElevation>
      {text}
    </ButtonModified>
  );
}
